import { useToast } from "vue-toastification";
import store from "../../../../store";
import useBase64 from "./../../../../packages/views/file-uploader/useBase64";

export default function usephotoUploader() {
    const toast = useToast()
    const {
        getBase64
    } = useBase64()

    function MBtoBytes(sizeMB) {
        return sizeMB * 1048576
    }

    function clearFiles(fileInput) {
        fileInput.value = ''
    }

    function exceedSizeMessage(sizeLimitMB) {
        toast.error(`Presiahli ste maximálnu sumárnu veľkosť súborov ${sizeLimitMB}MB`,)
    }

    function getSumFileSize(files) {
        const fileCount = files.length
        let fileSize = 0

        for (let i = 0; i < fileCount; i++) {
            fileSize += files[i].size // get file size
        }

        return fileSize
    }

    function isSuccesfulValidation(fileInput) {
        const { files } = fileInput
        const sizeLimitMB = store.getters['photoUploader/getSizeLimit']
        const sizeLimitBytes = MBtoBytes(sizeLimitMB)
        let error = false

        // exceed summary file size
        if (getSumFileSize(files) > sizeLimitBytes) {
            exceedSizeMessage(sizeLimitMB)
            error = true
        }

        if (error) {
            clearFiles(fileInput)
        }

        return !error
    }

    async function handleFiles(event, index) {
        const commitMethod = 'photoUploader/SET_FILE'
        const fileInput = event.target;
        // validation
        if (!isSuccesfulValidation(fileInput)) {
            return false
        }

        const files = await getBase64(fileInput.files)

        store.commit(commitMethod, { index, value: files })

        return true;
    }

    return {
        handleFiles,
    }
}
